import { Injectable } from "@angular/core";
import { ApiService } from "../../../services/api/api.service";
import { Observable } from "rxjs";
import { IPagination } from "../../../services/api/interface/pagination.interface";


@Injectable({
  providedIn:'root'
})

export class MedicalAdviceService{

  constructor(private readonly apiService:ApiService){}

  getList() {
    return this.apiService.get<any[]>('medical-advice')
  }

  getFilter(event: any, filter: any): Observable<IPagination> {
    return this.apiService.getFilter<IPagination>(`medical-advice/medical-advice-filter-list`, {event: event, filter: filter})
  }

  create(menu: any): Observable<any> {
    return this.apiService.post<any>('medical-advice/create', menu)
  }

  update(menu: any): Observable<any> {
    return this.apiService.patch<any>('medical-advice/update', menu);
  }
}
